import { ArrowRight, MessageCircle, MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { Logo } from "./Logo";
import { waLink, DEFAULT_WA_TEXT } from "../../lib/constants";
import { track } from "../../lib/tracking";

export const FinalCTA = ({ onBook }) => (
  <section data-testid="final-cta-section" className="relative overflow-hidden bg-teal py-28 md:py-40 text-ivory">
    <div className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[42rem] h-[42rem] rounded-full bg-champagne/10 blur-3xl" aria-hidden="true" />
    <div className="relative max-w-4xl mx-auto px-5 md:px-10 text-center">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-champagne">Limited-Period Package Offer</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-7 font-display text-4xl md:text-6xl font-light tracking-tight leading-[1.05]">
          Ready to Stop Shaving and Start Your Laser Hair Reduction Journey?
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-3">
          <span data-testid="final-regular-price" className="price-strike font-display text-2xl md:text-3xl font-light text-ivory/50">₹35,000</span>
          <ArrowRight className="w-5 h-5 text-champagne" strokeWidth={1.5} aria-hidden="true" />
          <span data-testid="final-special-price" className="font-display text-6xl md:text-7xl font-light text-champagne-light">₹22,500</span>
        </div>
        <p className="mt-4 font-mono text-xs uppercase tracking-[0.3em] text-ivory/60">10 Sessions + Annual Maintenance</p>
      </Reveal>
      <Reveal delay={0.24}>
        <div className="mt-12 flex flex-col sm:flex-row justify-center gap-4">
          <button
            onClick={() => { track("book_package_click", { placement: "final_cta" }); onBook(); }}
            data-testid="final-book-button"
            className="group inline-flex items-center justify-center gap-3 rounded-full bg-champagne px-10 py-4 text-sm font-bold uppercase tracking-[0.16em] text-teal-900 transition-colors duration-300 hover:bg-champagne-light"
          >
            Book Now
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
          </button>
          <a
            href={waLink(DEFAULT_WA_TEXT)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track("whatsapp_click", { placement: "final_cta" })}
            data-testid="final-whatsapp-button"
            className="inline-flex items-center justify-center gap-3 rounded-full border border-ivory/30 px-10 py-4 text-sm font-bold uppercase tracking-[0.16em] text-ivory transition-colors duration-300 hover:bg-ivory hover:text-teal"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.8} />
            WhatsApp Us
          </a>
        </div>
        <p className="mt-8 text-xs font-light text-ivory/50">
          Consultation required. Treatment suitability will be assessed by the doctor.
        </p>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-teal-900 text-ivory/60 py-14 border-t border-ivory/10">
    <div className="max-w-7xl mx-auto px-5 md:px-10">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
        <div>
          <Logo dark />
          <p className="mt-5 flex items-center gap-2 text-sm font-light">
            <MapPin className="w-4 h-4 text-champagne" strokeWidth={1.6} />
            Ameerpet, Hyderabad
          </p>
        </div>
        <p className="max-w-xl text-xs font-light leading-relaxed text-ivory/40">
          Results vary depending on hair type, skin type, hormones and individual response. Treatment suitability is
          determined after consultation. Laser hair reduction provides long-term hair reduction; maintenance sessions
          may be required. No-cost EMI is subject to eligibility and provider terms.
        </p>
      </div>
      <div className="rule-champagne mt-12 opacity-40" aria-hidden="true" />
      <p className="mt-8 text-[0.65rem] font-mono uppercase tracking-[0.25em] text-ivory/35">
        © {new Date().getFullYear()} Krystal Skin And Laser Clinic · Ameerpet, Hyderabad
      </p>
    </div>
  </footer>
);
